export default __webpack_public_path__ + "static/scaffold-acc-be754ed7ab63cbcfe1b5c751876b3e8f.jpg";